Promise.prototype.catchAll = function () {
  return this.catch(() => {})
}
